import React, { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'

import { GLOBALS } from '../../utils/Globals'
import { Context } from '../../Context'
import { Layout } from '../../components/Layout'

import { DatalistProgram } from '../../components/DataListProgram'
import { ProgramService } from '../../services/Program'

export const ProgramList = () => {
  const { isAuth: token } = useContext(Context)
  const dt = useRef(null)

  const columns = [
    {
      field: 'name',
      header: 'Nombre',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por nombre de programa',
    },
    {
      field: 'description',
      header: 'Descripción',
      sortable: true,
      filter: true,
      filterPlaceholder: 'Buscar por descripcion',
    },
    {
      field: 'status',
      header: 'Estado',
      sortable: true,
      filter: false,
    },
  ]

  const customActionButtons = ({ row }) => {
    return (
      <Link to={`${GLOBALS.menu.programs.viewprogram}/${row.id}`}>

        <Button
          type="button"
          icon="pi pi-chevron-circle-right"
          className="p-button-primary"
          tooltip="Ver"
        ></Button>
      </Link>
    )
  }

  return (
    <Layout>
      <DatalistProgram
        ref={dt}
        menuItem={GLOBALS.menu.programs}
        listItems={() => ProgramService.getAll(token)}
        bulkDelete={(ids) => ProgramService.bulkDelete(ids, token)}
        columns={columns}
        customActionButtons={customActionButtons}
      ></DatalistProgram>
    </Layout>
  )
}
